export const DisabledMixin = {
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    }
};
